export default "__VITE_PUBLIC_ASSET__135a57a0__"